<template>
    <div :id="'slidyThing-' + $vnode.key" :style="klassObj">
        <!--v-click-outside="DoSomething"-->
        <a href="javascript:void(0)" class="closebtn" v-on:click="closeButtonClicked">&times;</a>
        <div style="position: absolute;">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "SlidyThing",
        props: ["width", "openOn"],
        data: () => {
            return {
                show: false
            };
        },
        watch: {
            isHidden(newVal) {
                console.log(newVal)
            }
        },
        //directives: {
        //    'click-outside': {
        //        bind: function (el, binding, vnode) {
        //            el.clickOutsideEvent = function (event) {
        //                // here I check that click was outside the el and his children
        //                if (!(el == event.target || el.contains(event.target))) {
        //                    // and if it did, call method provided in attribute value
        //                    vnode.context[binding.expression](event);
        //                }
        //            };
        //            document.body.addEventListener('click', el.clickOutsideEvent)
        //        },
        //        unbind: function (el) {
        //            document.body.removeEventListener('click', el.clickOutsideEvent)
        //        },
        //    }
        //},
        computed: {
            panelWidth: function () {
                if (this.show && this.show == true) return this.width;
                else return 0;
            },
            klassObj: function () {
                let obj = {
                    height: "100%",
                    width: this.panelWidth,
                    position: "fixed",
                    "z-index": 1031,
                    top: 0,
                    "background-color": "white",
                    "overflow-x": "hidden",
                    "padding-top": "60px",
                    transition: "0.5s"
                };
                if (this.openOn && (this.openOn == "right")) {
                    obj.right = 0
                    obj['border-left'] = '1px solid #e8eef1'
                } else {
                    obj.left = 0;
                    obj['border-right'] = '1px solid #e8eef1'
                }

                return obj;
            },
            isHidden() {
                try {
                    var style = window.getComputedStyle(this.$el);
                    return (style.display === 'none')
                } catch {
                    return false
                }
            }
        },
        methods: {
            showPanel() {
                this.show = true;
                setTimeout(function () {
                    document.addEventListener('click', this.clickOutsideEvent)
                }.bind(this), 500)
            },
            hidePanel() {
                this.show = false;
                document.removeEventListener('click', this.clickOutsideEvent)
            },
            closeButtonClicked() {
                this.show = false;
                document.removeEventListener('click', this.clickOutsideEvent)
            },
            clickOutsideEvent(event) {
                if (this.show == true) {
                    //console.log(event)
                    //console.log(this.$el)
                    if (!(this.$el == event.target || this.$el.contains(event.target))) {
                        this.show = false
                        document.removeEventListener('click', this.clickOutsideEvent)
                    }
                }
            },
            //DoSomething() {
            //    setTimeout(function () {
            //        this.show = false
            //    }.bind(this), 1000)
            //}
        },
        deactivated() {
            this.show = false;
            document.removeEventListener('click', this.clickOutsideEvent)
        }
    };
</script>
<style scoped>

    a {
        padding: 8px 8px 8px 32px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
        transition: 0.3s;
    }

        a:hover {
            color: #f1f1f1;
        }

    .closebtn {
        position: absolute;
        top: 0;
        right: 25px;
        font-size: 36px;
        margin-left: 50px;
    }
</style>